export const PerioGrid = {
  flow: 'y',
  gap: '0',
  background: 'inkMid',
  round: 'Z',
  border: '1px solid inkBorder',
  overflow: 'auto',

  GridHeader: {
    flow: 'x',
    gap: '0',
    borderBottom: '2px solid inkBorder',
    position: 'sticky',
    top: '0',
    background: 'inkMid',
    zIndex: '1',

    LabelCell: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '700',
      fontSize: 'Y',
      color: 'inkMuted',
      textTransform: 'uppercase',
      letterSpacing: 'X',
      borderRight: '1px solid inkBorder',
      text: '{{ metric | polyglot }}'
    },

    ToothColumns: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: 'Y',
        color: 'inkText',
        borderRight: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          return { text: String(t) }
        })
      }
    }
  },

  PDRow: {
    flow: 'x',
    gap: '0',
    borderBottom: '1px solid inkBorder',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: '{{ pdMm | polyglot }}'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var pd = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].pd
          var val = pd || 2
          return {
            text: String(val),
            color: val >= 6 ? 'perioCritical' : val >= 4 ? 'perioWarning' : 'perioHealthy',
            background: val >= 6 ? 'perioCritical.10' : val >= 4 ? 'perioWarning.10' : 'perioHealthy.10'
          }
        })
      }
    }
  },

  GMRow: {
    flow: 'x',
    gap: '0',
    borderBottom: '1px solid inkBorder',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: '{{ gmMm | polyglot }}'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder',
        color: 'inkText'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var gm = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].gm
          return { text: String(gm || 0) }
        })
      }
    }
  },

  CALRow: {
    flow: 'x',
    gap: '0',
    borderBottom: '1px solid inkBorder',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: '{{ calMm | polyglot }}'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var cal = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].cal
          var val = cal || 2
          return {
            text: String(val),
            color: val >= 6 ? 'perioCritical' : val >= 4 ? 'perioWarning' : 'perioHealthy',
            background: val >= 6 ? 'perioCritical.10' : val >= 4 ? 'perioWarning.10' : 'perioHealthy.10'
          }
        })
      }
    }
  },

  BOPRow: {
    flow: 'x',
    gap: '0',
    borderBottom: '1px solid inkBorder',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: 'BOP'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var bop = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].bop
          return {
            text: bop ? '+' : '-',
            color: bop ? 'perioBleeding' : 'perioHealthy'
          }
        })
      }
    }
  },

  SuppRow: {
    flow: 'x',
    gap: '0',
    borderBottom: '1px solid inkBorder',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: '{{ suppuration | polyglot }}'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var supp = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].suppuration
          return {
            text: supp ? '+' : '-',
            color: supp ? 'red' : 'inkMuted'
          }
        })
      }
    }
  },

  FurcRow: {
    flow: 'x',
    gap: '0',
    borderBottom: '1px solid inkBorder',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: '{{ furcation | polyglot }}'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder',
        color: 'inkText'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var furc = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].furcation
          return { text: String(furc || 0) }
        })
      }
    }
  },

  MobRow: {
    flow: 'x',
    gap: '0',

    RowLabel: {
      width: 'E',
      minWidth: 'E',
      padding: 'Y Z',
      fontWeight: '600',
      fontSize: 'Y',
      color: 'inkText',
      borderRight: '1px solid inkBorder',
      text: '{{ mobility | polyglot }}'
    },

    Cells: {
      flow: 'x',
      gap: '0',
      childExtends: {
        width: 'B',
        minWidth: 'B',
        padding: 'Y X',
        textAlign: 'center',
        fontSize: 'Y',
        fontWeight: '600',
        borderRight: '1px solid inkBorder',
        color: 'inkText'
      },
      $collection: (el, s) => {
        var teeth = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28]
        return teeth.map(function (t) {
          var mob = s.root.perioData && s.root.perioData[t] && s.root.perioData[t].mobility
          return { text: String(mob || 0) }
        })
      }
    }
  }
}
